(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chic-article"]) return;
  try {
    
function initChicArticle(){const root=document.querySelector('.ce-article');if(!root||root.dataset.ready)return;root.dataset.ready='true';const headings=[...root.querySelectorAll('.ce-content h2')],list=root.querySelector('.ce-toc ol');headings.forEach((heading,index)=>{if(!heading.id)heading.id='ce-heading-'+index;const item=document.createElement('li'),link=document.createElement('a');link.href='#'+encodeURIComponent(heading.id);link.textContent=heading.textContent;item.append(link);list.append(item);});if(headings.length)root.querySelector('.ce-sidebar').hidden=false;const copy=root.querySelector('[data-ce-copy]');copy?.addEventListener('click',async()=>{const status=root.querySelector('.ce-copy-status');try{await navigator.clipboard.writeText(copy.dataset.url);status.textContent=copy.dataset.success;}catch{status.textContent=copy.dataset.error;}});}
initChicArticle();document.addEventListener('shopify:section:load',initChicArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-cart-main"]) return;
  try {
    
function initChicCart(){const form=document.querySelector('.cx-form');if(!form||form.dataset.ready)return;form.dataset.ready='true';const update=form.querySelector('[data-cx-update]');form.addEventListener('click',event=>{const button=event.target.closest('[data-cx-step]');if(!button)return;const input=button.parentElement.querySelector('input');input.value=String(Math.max(0,(parseInt(input.value,10)||0)+Number(button.dataset.cxStep)));form.requestSubmit(update);});form.addEventListener('change',event=>{if(event.target.matches('input[name="updates[]"]')&&event.target.checkValidity())form.requestSubmit(update);});}
initChicCart();document.addEventListener('shopify:section:load',initChicCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-collection-main"]) return;
  try {
    
function initChicCollection(){
 const root=document.querySelector('.cc-collection');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const panel=root.querySelector('.cc-filter-panel'),grid=root.querySelector('#cc-products'),loader=root.querySelector('[data-cc-infinite]');
 if(window.matchMedia('(max-width:749px)').matches)panel.open=false;
 root.querySelector('#cc-sort').addEventListener('change',()=>root.querySelector('#cc-filters').requestSubmit());
 root.querySelectorAll('[data-cc-view]').forEach(button=>button.addEventListener('click',()=>{grid.dataset.view=button.dataset.ccView;root.querySelectorAll('[data-cc-view]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
 if(!loader)return;
 let busy=false,failed=false,observer;
 const status=loader.querySelector('[role="status"]');
 async function loadMore(){
  const link=loader.querySelector('[data-cc-next]');if(busy||!link||!root.isConnected)return;
  busy=true;failed=false;loader.setAttribute('aria-busy','true');grid.setAttribute('aria-busy','true');status.textContent=loader.dataset.loading;
  try{
   const url=new URL(link.href,location.origin);url.searchParams.set('section_id',root.dataset.sectionId);
   const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Collection request failed');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   const incoming=doc.querySelector('.cc-collection'),cards=incoming?.querySelectorAll('#cc-products > .cc-card');
   if(!cards?.length)throw new Error('Missing products');
   if(!root.isConnected)return;
   grid.append(...cards);
   const next=incoming.querySelector('[data-cc-next]');
   if(next){link.href=next.href;}else{link.remove();observer?.disconnect();}
   status.textContent='';
  }catch(error){failed=true;status.textContent=loader.dataset.error;}
  finally{busy=false;loader.removeAttribute('aria-busy');grid.removeAttribute('aria-busy');}
 }
 loader.addEventListener('click',event=>{if(event.target.closest('[data-cc-next]')){event.preventDefault();loadMore();}});
 if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)&&!failed)loadMore();},{rootMargin:'0px 0px 600px 0px'});observer.observe(loader);}
}
initChicCollection();document.addEventListener('shopify:section:load',initChicCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-home-hero"] && !Shopify.designMode) return;
  try {
    
function syncChicHeroHeight(){const header=document.querySelector('.ch-header'),announcement=document.querySelector('.ch-announcement');document.documentElement.style.setProperty('--ch-header-height',Math.ceil((header?.getBoundingClientRect().height||0)+(announcement?.getBoundingClientRect().height||0))+'px');}
syncChicHeroHeight();if('ResizeObserver' in window){const observer=new ResizeObserver(syncChicHeroHeight);document.querySelectorAll('.ch-header,.ch-announcement').forEach(element=>observer.observe(element));}window.addEventListener('resize',syncChicHeroHeight);
function initChicHero(root){root.querySelectorAll('.ch-hero').forEach(hero=>{if(hero.dataset.ready)return;hero.dataset.ready='true';const slides=[...hero.querySelectorAll('[data-ch-slide]')],dots=[...hero.querySelectorAll('[data-ch-dot]')];let index=0;const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));};hero.querySelector('[data-ch-prev]')?.addEventListener('click',()=>show(index-1));hero.querySelector('[data-ch-next]')?.addEventListener('click',()=>show(index+1));dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));});}initChicHero(document);document.addEventListener('shopify:section:load',e=>initChicHero(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-product-main"] && !Shopify.designMode) return;
  try {
    
function caInit(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const slides=[...root.querySelectorAll('.ca-slide')], thumbs=[...root.querySelectorAll('[data-thumb]')];
 function show(id){if(!slides.some(el=>el.dataset.mediaId===String(id)))return;slides.forEach(el=>{el.hidden=el.dataset.mediaId!==String(id);if(el.hidden)el.querySelectorAll('video').forEach(v=>v.pause());});thumbs.forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.thumb===String(id))));}
 if(slides.length&&!slides.some(s=>!s.hidden))show(slides[0].dataset.mediaId);
 root.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>{const i=slides.findIndex(el=>!el.hidden);show(slides[(i+Number(b.dataset.galleryStep)+slides.length)%slides.length].dataset.mediaId);}));
 thumbs.forEach(b=>b.addEventListener('click',()=>show(b.dataset.thumb)));
 root.querySelectorAll('[data-quantity]').forEach(b=>b.addEventListener('click',()=>{const input=root.querySelector('[name="quantity"]');input.value=Math.max(1,(parseInt(input.value)||1)+Number(b.dataset.quantity));input.dispatchEvent(new Event('change',{bubbles:true}));}));
 root.querySelector('[name="quantity"]').addEventListener('change',e=>{e.target.value=Math.max(1,parseInt(e.target.value)||1);});
 let request;
 root.querySelectorAll('.ca-options input').forEach(input=>input.addEventListener('change',async()=>{
  if(request)request.abort();request=new AbortController();
  const form=root.querySelector('.ca-form'),add=root.querySelector('[data-add]'),status=root.querySelector('.ca-status');
  add.disabled=true;root.querySelector('.ca-buy')?.setAttribute('disabled','');root.querySelector('[data-variant-id]').disabled=true;root.querySelector('.ca-payment')?.setAttribute('inert','');
  const url=new URL(root.dataset.url,location.origin);url.searchParams.set('section_id',root.dataset.section);url.searchParams.set('option_values',[...root.querySelectorAll('.ca-options input:checked')].map(x=>x.dataset.optionId).join(','));
  try{
   const response=await fetch(url,{signal:request.signal});if(!response.ok)throw Error();
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');const next=doc.querySelector('[data-ca-product]');if(!next)throw Error();
   const variant=next.querySelector('[data-variant-id]');root.querySelector('[data-variant-id]').value=variant.value;root.querySelector('[data-variant-id]').disabled=false;
   root.querySelector('.ca-price').innerHTML=next.querySelector('.ca-price').innerHTML;
   add.innerHTML=next.querySelector('[data-add]').innerHTML;add.disabled=next.querySelector('[data-add]').disabled;const buy=root.querySelector('.ca-buy');if(buy)buy.disabled=add.disabled;
   root.querySelectorAll('[data-selected-option]').forEach((el,i)=>el.textContent=next.querySelectorAll('[data-selected-option]')[i]?.textContent||'');
   const selected=next.querySelector('.ca-slide:not([hidden])');if(selected)show(selected.dataset.mediaId);
   const nextUrl=new URL(location.href);if(variant.value)nextUrl.searchParams.set('variant',variant.value);history.replaceState({},'',nextUrl);
   root.querySelector('.ca-payment')?.removeAttribute('inert');form.dispatchEvent(new Event('change',{bubbles:true}));status.textContent='';
  }catch(error){if(error.name==='AbortError')return;location.assign(url.toString().replace(/([?&])section_id=[^&]*&?/,'$1'));}
 }));
}
document.querySelectorAll('[data-ca-product]').forEach(caInit);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ca-product]').forEach(caInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chic-product-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('a[href="#looxReviewsFrame"]');if(!link)return;const reviews=document.querySelector('.ca-full-reviews');if(!reviews)return;event.preventDefault();reviews.open=true;reviews.scrollIntoView({behavior:'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');

    this._rafPending = false;
    this.parallaxEffect = () => {
      if (this._rafPending) return;
      this._rafPending = true;
      requestAnimationFrame(() => {
        const scrollPosition = window.pageYOffset;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const parallaxValue = (scrollPosition / maxScroll) * 50;
        if (image) image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
        this._rafPending = false;
      });
    };

    const section = document.getElementById(sectionId);
    this.style.transform = 'translateY(0)';

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect, { passive: true });
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });
    this._observer.observe(section);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.parallaxEffect);
    if (this._observer) this._observer.disconnect();
  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))},{passive:true})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
